import axios from 'axios';
import { saveAs } from 'file-saver';

export const getBenefeciaries = async (id) => {
  const res = await axios.get(`/employees/${id}/beneficiaries`);
  return res.data.beneficiaries;
};

export const employeeDeleteRequest = async ({ id }) => {
  const res = await axios.delete(`/requests/${id}`);
  return res;
};

export const getPatientRequests = async ({ id, params }) => {
  const res = await axios.get(`/employees/${id}/patient-requests?${params.toString()}`);
  if (res.status !== 200) {
    throw new Error('Network response was not ok');
  }
  return res;
};

// id omitted = the caller's own report; an id needs ADMIN.
export const downloadReport = async ({ id, name, format }) => {
  const res = await axios.get(`/employees/${id || 'me'}/report?format=${format}`, {
    responseType: 'blob'
  });
  saveAs(res.data, `${name}-medical-report-${new Date().getFullYear()}.${format}`);
};

export const downloadAllReports = async () => {
  const res = await axios.get('/employees/all/report?format=xlsx', { responseType: 'blob' });
  saveAs(res.data, `all-employees-medical-report-${new Date().getFullYear()}.xlsx`);
};
